import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { forkJoin } from "rxjs";
import { DataService, TextDocumentVersion } from "../../../shared/dataService";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import HtmlDiff from "htmldiff-js";

@Component({
  selector: "app-document-compare",
  templateUrl: "./document-compare.component.html",
  styleUrls: ["./document-compare.component.scss"],
})
export class DocumentCompareComponent implements OnInit {
  version1: TextDocumentVersion | null = null;
  version2: TextDocumentVersion | null = null;
  documentId: string | null = null;
  versionId1: string | null = null;
  versionId2: string | null = null;
  isLoading = true;
  isError = false;
  errorMessage = "";

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.documentId = this.route.snapshot.paramMap.get("id");
    this.versionId1 = this.route.snapshot.queryParamMap.get("id1");
    this.versionId2 = this.route.snapshot.queryParamMap.get("id2");

    if (!this.documentId || !this.versionId1 || !this.versionId2) {
      this.isError = true;
      this.errorMessage = "Missing required parameters for comparison.";
      this.isLoading = false;
      return;
    }

    this.fetchVersionsForComparison();
  }

  private fetchVersionsForComparison(): void {
    this.isLoading = true;
    this.isError = false;

    const version1$ = this.dataService.getDocumentVersionById(
      this.documentId!,
      this.versionId1!,
    );
    const version2$ = this.dataService.getDocumentVersionById(
      this.documentId!,
      this.versionId2!,
    );

    forkJoin([version1$, version2$]).subscribe({
      next: ([version1, version2]) => {
        this.version1 = version1;
        this.version2 = version2;
        this.isLoading = false;
      },
      error: (error) => {
        console.error("Error fetching versions for comparison:", error);
        this.isError = true;
        this.errorMessage =
          "Could not load versions to compare. Please try again later.";
        this.isLoading = false;
      },
    });
  }

  getDiff(): SafeHtml {
    const oldHtml = (this.version1 && this.version1.text) || "";
    const newHtml = (this.version2 && this.version2.text) || "";

    if (!oldHtml && !newHtml) {
      return this.sanitizer.bypassSecurityTrustHtml("");
    }

    try {
      const diffHtml = HtmlDiff.execute(oldHtml, newHtml);
      return this.sanitizer.bypassSecurityTrustHtml(diffHtml);
    } catch (error) {
      console.error("Error generating diff:", error);
      return this.sanitizer.bypassSecurityTrustHtml(
        "<p>Error generating comparison. Please try again.</p>",
      );
    }
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
}
